export default "__VITE_ASSET__DlE23JBj__"